export const MODULE_KEY_BY_PERMISSION_GROUP = {
  diary: 'diaries',
  parties: 'parties',
  mercury: 'mercury',
  inbox: 'inbox',
  financials: 'workkards.financial',
  authorizedStates: 'admin.user.authorized_states',
  letters: 'letters',

  can_manage_atlas: 'admin.atlas',
  can_manage_communication: 'admin.communication',
  can_access_bulk_inbox: 'bulk_inbox',
  can_connect_mailbot: 'admin.mailbot'
};


// section).
export const MODULE_KEY_BY_PERMISSION_ID = {
  can_manage_contracts: 'admin.relationship.manage_contract',
  can_add_watcher: 'admin.user.watchers',
  can_act_as_hidden_watcher: 'admin.user.watchers',
  can_accept_reject_bid: 'admin.activity.accept_reject_bid',
  can_clone_notes: 'notes.clone_note',
  can_close_act_in_views: 'admin.views.close_activity',
  can_complete_diary_in_views: 'admin.views.complete_diary'
};
